var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.058,
    height: 25.059,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-replay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    className: "cls-1",
    d: "M632.59-118.947a12.544 12.544 0 01-12.529-12.53 12.544 12.544 0 0112.529-12.529 12.543 12.543 0 0112.529 12.529 12.543 12.543 0 01-12.529 12.53zm0-23.884a11.367 11.367 0 00-11.354 11.354 11.367 11.367 0 0011.354 11.355 11.368 11.368 0 0011.355-11.355 11.368 11.368 0 00-11.355-11.354z",
    transform: "translate(-620.061 144.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    className: "cls-1",
    d: "M631.724-137.651v-1.868a.487.487 0 00-.306-.457.484.484 0 00-.539.107l-2.65 2.65a.489.489 0 00-.146.35.491.491 0 00.146.349l2.65 2.65a.486.486 0 00.346.145.52.52 0 00.192-.038.489.489 0 00.306-.458v-2.042a4.493 4.493 0 014.108 4.462 4.508 4.508 0 01-4.5 4.5 4.51 4.51 0 01-4.5-4.5.7.7 0 00-.7-.694.7.7 0 00-.694.694 5.9 5.9 0 005.894 5.9 5.9 5.9 0 005.894-5.9 5.884 5.884 0 00-5.501-5.85z",
    transform: "translate(-618.639 145.062)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplay);
export default __webpack_public_path__ + "static/media/icon-replay.883a0a5b.svg";
export { ForwardRef as ReactComponent };